import { FormGroup, Validators } from '@angular/forms';

import { CompensationValidationAction } from './compensation-validation-action.enum';
import { FieldValidatorsMap, FormValidatorsMap } from '../interfaces';

import { ObjectLike } from 'app/interfaces';
import { FormModel } from 'app/models';
import { requiredWithOtherValue, requiredWithout, requireLength, updateValidity } from 'app/validators';

export class CompensationRules extends FormModel<CompensationValidationAction> {
    baseValidators: FieldValidatorsMap = {
        automaticReloadAmount: [
            Validators.min(0),
            requiredWithout(['isUnlimited']),
            updateValidity(['maxCompensation']),
        ],
        categories: [requireLength()],
        compensationPercentage: [Validators.required, Validators.min(0), Validators.max(100)],
        isUnlimited: [updateValidity(['automaticReloadAmount'])],
        maxCompensation: [Validators.min(0)],
        name: [Validators.required],
        nextAutomaticReload: [Validators.required],
        nextResetDate: [requiredWithOtherValue(['resetEnabled'], true)],
        resetEnabled: [updateValidity(['nextResetDate', 'resetIntervalEnabled', 'resetInterval'])],
        resetInterval: [requiredWithOtherValue(['resetIntervalEnabled'], true)],
        resetIntervalEnabled: [updateValidity(['resetInterval'])],
    };
    formValidators: FormValidatorsMap = {};

    getStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(CompensationValidationAction.Store, formFrom);
    }

    getUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(CompensationValidationAction.Update, formFrom);
    }
}
